import * as ActionTypes from "../actions/types";
import questionnaireStructure from "../data/questionnaire_structure.json";

const INITIAL_STATE = {
  isEdit: false,
  isOpen: false,
  structure: questionnaireStructure,
  businessRepresentativeOptions:
    questionnaireStructure.steps
      .find((step) => step.type === "multiple_selection")
      ?.fields?.find((field) => field.name === "field_product_categories")
      ?.options || [],
  userTypes: [],
  userTypesLoading: false,
  userTypesError: null,
  selectedUserType: null,
  creating: false,
  createError: null,
  updating: false,
  updateError: null,
};

function editQuestionaire(state, action) {
  state.isEdit = action.payload;
}

function openQuestionaire(state, action) {
  state.isOpen = action.payload;
}

function fetchUserTypes(state, action) {
  state.userTypesLoading = true;
  state.userTypesError = null;
}

function fetchUserTypesSuccess(state, action) {
  state.userTypesLoading = false;
  state.userTypes = action.payload;
  state.userTypesError = null;
}

function fetchUserTypesFailed(state, action) {
  state.userTypesLoading = false;
  state.userTypesError = action.payload;
}

function setSelectedUserType(state, action) {
  state.selectedUserType = action.payload;
}

function createUserQuestionnaire(state, action) {
  state.creating = true;
  state.createError = null;
}

function createUserQuestionnaireSuccess(state, action) {
  state.creating = false;
  state.createError = null;
}

function createUserQuestionnaireFailed(state, action) {
  state.creating = false;
  state.createError = action.payload;
}

function updateUserQuestionnaire(state, action) {
  state.updating = true;
  state.updateError = null;
}

function updateUserQuestionnaireSuccess(state, action) {
  state.updating = false;
  state.updateError = null;
}

function updateUserQuestionnaireFailed(state, action) {
  state.updating = false;
  state.updateError = action.payload;
}

export const userQuestionaire = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.EDIT_QUESTIONAIRE]: editQuestionaire,
    [ActionTypes.OPEN_QUESTIONAIRE]: openQuestionaire,
    [ActionTypes.FETCH_USER_TYPES]: fetchUserTypes,
    [ActionTypes.FETCH_USER_TYPES_SUCCESS]: fetchUserTypesSuccess,
    [ActionTypes.FETCH_USER_TYPES_FAILED]: fetchUserTypesFailed,
    [ActionTypes.SET_SELECTED_USER_TYPE]: setSelectedUserType,
    [ActionTypes.CREATE_USER_QUESTIONNAIRE]: createUserQuestionnaire,
    [ActionTypes.CREATE_USER_QUESTIONNAIRE_SUCCESS]:
      createUserQuestionnaireSuccess,
    [ActionTypes.CREATE_USER_QUESTIONNAIRE_FAILED]:
      createUserQuestionnaireFailed,
    [ActionTypes.UPDATE_USER_QUESTIONNAIRE]: updateUserQuestionnaire,
    [ActionTypes.UPDATE_USER_QUESTIONNAIRE_SUCCESS]:
      updateUserQuestionnaireSuccess,
    [ActionTypes.UPDATE_USER_QUESTIONNAIRE_FAILED]:
      updateUserQuestionnaireFailed,
  },
};
